import { Checkbox } from '@/components/ui/checkbox';

export function PrivacyConsent({ checked, onChange, className = '' }) {
  return (
    <label className={`flex items-start gap-2.5 cursor-pointer ${className}`}>
      <Checkbox
        data-testid="privacy-consent"
        checked={checked}
        onCheckedChange={onChange}
        className="mt-0.5 border-stone-600 data-[state=checked]:bg-amber-700 data-[state=checked]:border-amber-700"
      />
      <span className="text-xs leading-relaxed" style={{ color: 'var(--app-text-muted, #78716c)' }}>
        Я даю согласие на обработку персональных данных и принимаю условия{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer"
          className="underline underline-offset-2" style={{ color: 'var(--app-accent, #b45309)' }}>
          Политики конфиденциальности
        </a>
      </span>
    </label>
  );
}
